import React from "react";

const socials = [
  {
    href: "https://www.instagram.com/andyfransisko",
    icon: "fa-instagram",
    label: "Instagram",
  },
  {
    href: "https://www.linkedin.com/in/andyfransisko/",
    icon: "fa-linkedin-square",
    label: "LinkedIn",
  },
  {
    href: "https://dribbble.com/andyfransisko",
    icon: "fa-dribbble",
    label: "Dribbble",
  },
  {
    href: "https://behance.net/andyfransisko",
    icon: "fa-behance",
    label: "Behance",
  },
];

export default function SocialLinks({ className = "" }) {
  return (
    <div className={`flex gap-5 ${className}`}>
      {socials.map((social) => (
        <a
          key={social.label}
          href={social.href}
          target="_blank"
          rel="noreferrer"
          aria-label={social.label}
          className="text-2xl text-white hover:text-teal-500 hover:-translate-y-1 transition-all duration-200 inline-block"
        >
          <i className={`fa ${social.icon}`} aria-hidden="true"></i>
        </a>
      ))}
    </div>
  );
}
